import { Component } from '@angular/core';
import { MenuItems, PageInterface } from 'src/app/services/config/menu';
import { CoreProvider } from 'src/app/services/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page-selector',
  styleUrls: ['page-selector.scss'],
  templateUrl: 'page-selector.html'
})
export class PageSelectorComponent {

  menuitems = MenuItems;

  constructor(public core:CoreProvider, private router: Router) {}

  navigate(page: PageInterface) {
    this.router.navigateByUrl(page.url);
  }

}
